<template>
  <div>
    <apexchart v-if="imagesLoaded"
               type="bar"
               :options="chartOptions"
               :series="series">
    </apexchart>
    <v-row v-if="1===2">
      <v-col cols="6">
        <pre>{{ pages }}</pre>
      </v-col>
      <v-col cols="6">
        <pre>{{ blobs }}</pre>
      </v-col>
    </v-row>
  </div>
</template>
<style lang="scss">
.apexcharts-canvas {
  .PageThumbnail {
    background-color: rgba(0, 0, 0, .75);
    padding: 4px;
    color: #FFFFFF;
    text-transform: uppercase;

    img {
      width: 200px;
      height: auto;
    }
  }
}
</style>
<script>
import {orderBy} from 'lodash';

function formatDuration(value) {
  const dt = new Date(value * 1000);
  const hours = dt.getUTCHours();
  const minutes = dt.getUTCMinutes();
  const seconds = dt.getSeconds();
  if (hours) {
    return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
  }
  return minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
}

export default {
  props: {
    pages: {
      type: Array,
      required: true,
    },
  },
  watch: {
    pages: (pages) => {
      console.log('watching pages', pages.length);
      this.initImages(pages.filter(p => p.total_seconds > 0));
    }
  },
  data() {
    return {
      blobs: [],
      imagesLoaded: false,
    }
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          animations: { // @see https://apexcharts.com/docs/options/chart/animations/
            easing: 'easein',
          },
          height: 'auto',
          toolbar: {
            show: false,
          },
          type: 'bar',
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: { // @see https://apexcharts.com/docs/options/xaxis/
          categories: this.pagesWithTime.map(p => `Page ${p.page_number}`),
          labels: {
            hideOverlappingLabels: true,
            rotateAlways: true,
          }
        },
        yaxis: { // @see https://apexcharts.com/docs/options/yaxis/
          labels: {
            formatter: formatDuration
          },
        },
        fill: {
          opacity: 1
        },
        tooltip: { // @see https://apexcharts.com/docs/options/tooltip/
          followCursor: false,
          marker: {
            show: false,
          },
          custom: ({series, seriesIndex, dataPointIndex, w}) => {
            const page = this.pagesWithTime[dataPointIndex];
            if (!page) {
              console.log('Page not found');
              return null;
            }
            //return `<div class="PageThumbnail">DPI: ${dataPointIndex}, Page: ${page.page_number}</div>`;
            //console.log('Tooltip for page', dataPointIndex, page.page_number);
            if (this.blobs.length > dataPointIndex) {
              const blob = this.blobs[dataPointIndex];
              if (blob && blob.blobURL) {
                return `<div class="PageThumbnail">
<img src="${blob.blobURL}" class="PageThumbnail__Thumbnail" />
<div class="d-flex justify-space-between">
<div>
  <div>Page</div>
  <div>${page.page_number} / ${this.pages.length}</div>
</div>
<div class="text-right">
  <div>Time Spent</div>
  <div>${page.duration_time}</div>
</div>
</div>
</div>`
              }
            }
            return null;
          }
        }
      };
    },
    series() {
      return [
        {
          name: 'Time',
          data: this.pagesWithTime.map(p => p.total_seconds),
        },
      ];
    },
    pagesWithTime() {
      return this.pages.filter(p => p.total_seconds > 0);
    },
  },
  created() {
    this.initImages(this.pagesWithTime);
  },
  methods: {
    async initImages(pages) {
      console.log('initImages() START');
      this.imagesLoaded = false;
      this.blobs = [];
      try {
        const blobs = [];
        const axiosConfig = {
          responseType: 'arraybuffer',
          withCredentials: false,
        };
        for (const p of pages) {
          try {
            const {data} = await axios.get(p.url, axiosConfig);
            // How to transform image from get request to base64
            // @see https://github.com/axios/axios/issues/513#issuecomment-278864015
            let b64encoded = btoa([].reduce.call(new Uint8Array(data), function (p, c) {
              return p + String.fromCharCode(c)
            }, ''))
            let mimetype = 'image/jpeg'
            const blobURL = `data:${mimetype};base64,${b64encoded}`;
            blobs.push({...p, blobURL});
            console.log('Stored image for page', p.page_number);
          } catch (e) {
            console.log('Could not store the blob URL for page', p.page_number, e.message);
          }
        }
        this.blobs = orderBy(blobs, ['page_number'], ['asc']);
        console.log(`initImages() END - loaded ${blobs.length} images`);
      } catch (e) {
        console.log(`initImages() exception`, e.message);
        this.blobs = [];
      } finally {
        this.imagesLoaded = true;
      }
    }
  }
}
</script>
